type JwtPayload = { exp?: number; [key: string]: any } | null;

const padBase64 = (base64: string) => {
    base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) {
        base64 += '='.repeat(4 - pad);
    }
    return base64;
};

const parseJwtPayload = (token?: string): JwtPayload => {
    if (!token) {
        return null;
    }
    const parts = token.split('.');
    if (parts.length < 2) {
        return null;
    }
    try {
        const payload = parts[1];
        const decoded = atob(padBase64(payload));
        return JSON.parse(decoded) as JwtPayload;
    } catch {
        return null;
    }
};

export const isJwtExpired = (token?: string): boolean | null => {
    const payload = parseJwtPayload(token);
    if (!payload) {
        return null;
    }
    if (typeof payload.exp !== 'number') {
        return null;
    }
    const nowSeconds = Math.floor(Date.now() / 1000);
    return payload.exp <= nowSeconds;
};
